import { ReactComponent as NotFoundSvg } from '#/static/NotFound.svg';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import ErrorPage from './ErrorPage';

interface RecordNotFoundProps {
  /** Path to navigate to when the button is clicked. Falls back to /dashboard if omitted. */
  backUrl?: string;
}

const RecordNotFound: React.FC<RecordNotFoundProps> = ({ backUrl }) => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate(backUrl ?? '/dashboard');
  };

  return (
    <ErrorPage
      svg={NotFoundSvg}
      message="The item you are looking for is not available."
      buttonLabel="Back to List"
      onButtonClick={handleBackClick}
    />
  );
};

export default React.memo(RecordNotFound);
